import React, { useState, useEffect } from "react";
import axios from "axios";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { CiShare1 } from "react-icons/ci";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { Link } from "react-router-dom";
import { FaEllipsisVertical } from "react-icons/fa6";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { LiaUndoAltSolid } from "react-icons/lia";
import { BiRecycle } from "react-icons/bi";
import { RxReload } from "react-icons/rx";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminProcessButton from "../../../components/CommonComponents/AdminProcessButton";
import AdminVideoStatus from "../../../components/CommonComponents/AdminVideoStatus";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { connect } from "react-redux";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import useTablePage from "../../../components/CommonComponents/useTablePage";



function Allvideo({ siteTheme, permissionData }) {

  const { fetchRequest, deleteImageFile } = useMyContext()
  const headers = getItemToken('access_token')
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/video-list`
  const bannerToggle = `${BaseUrl}/admin/videos-slider`
  const multiDelete = `${BaseUrl}/admin/videos/multi-delete`
  const languageApi = `${BaseUrl}/admin/User-Translate-Language`
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [total, setTotal] = useState('')
  const [languageCode, setLanguageCode] = useState('');

  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })

  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        type, page,
        limit: formData?.title ? total?.count_all : limit,
        search: formData?.title,
        soft_delete: draft
      },
      data: {},
    })
      .then(response => {
        const result = response;
        const updatedList = result?.data?.map((item) => {
          const UploadStatus = item?.uploaded_by_role;
          return {
            ...item, uploaded_by_role: UploadStatus,
          };
        });
        setApiData(updatedList);
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        search: find === "ALL" ? null : formData?.title,
        type: null,
        page: 1,
        limit: find === "ALL" ? total?.count_all : total?.totalItems,
        soft_delete: draft,
      },
      data: {},
    });

    let updatedList;

    if (find === "ALL") {
      // Export everything
      updatedList = data?.data || [];
    } else {
      // Export only selected rows
      if (!itemToDelete || itemToDelete.length === 0) {
        alert("Please select at least one row to export.");
        return;
      }
      updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
      if (!updatedList || updatedList.length === 0) {
        alert("Selected data not found.");
        return;
      }
    }

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "TITLE": item?.title,
      "DURATION": item?.duration,
      "TRANSCODING STATUS": item?.current_status,
      "UPLOADED BY ROLE": item?.uploaded_by_role,
      "VIDEO STATUS": item?.video_status,
      "UPLOADED BY": item?.upload_on,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "VIDEO-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "VIDEO-LIST", [
        "S.NO", "TITLE", "DURATION", "TRANSCODING STATUS", "UPLOADED BY ROLE", "VIDEO STATUS", "UPLOADED BY"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "VIDEO-LIST", [
        "S.NO", "TITLE", "DURATION", "TRANSCODING STATUS", "UPLOADED BY ROLE", "VIDEO STATUS", "UPLOADED BY"
      ]);
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "Videos");
  }

  const handleConfirmDelete = async (actionType) => {
    setShowOverlay(true);
    await handleDeleteImage();
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete, action: actionType || deleteActionType },
    })
      .then(async response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([])
          setShowOverlay(false)
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message)
        setShowOverlay(false)
      })
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
    setDeleteActionType(2)
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
    }
  };
  const singlePeramanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setDeleteActionType(1)
  }
  const handleDeletedata = (actionType) => {
    handleConfirmDelete(actionType);
    closeModal();
  };
  // console.log(translateCheckout, languageCode)
  //Bootstrap Table util start
  // console.log(siteTheme?.translate_checkout);

  const columns = [
    {
      dataField: "id",
      text: "Id",
      colStyle: "px-3",
      formatter: (cell, row) => (
        <span className="theme-text-color table-heading">
          {row?.id ?? cell}
        </span>
      ),
      sort: true,
    },
    {
      dataField: "title",
      text: "Videos",
      width: "30%",
      colStyle: "px-5",
      formatter: (cell, row) => {
        const baseUrl = process.env.REACT_APP_Baseurl_Frontend?.replace(/\/$/, '');
        const slug = row?.slug || row?.artist_slug;
        const title = row?.title || row?.albumname || row?.artist_name;
        const shouldTranslate = siteTheme?.translate_checkout === 1;
        const videoPath = shouldTranslate
          ? `${baseUrl}/${languageCode}/videos/${slug}`
          : `${baseUrl}/videos/${slug}`;
        // console.log("Video Path:", videoPath);
        return (
          <div className="d-flex justify-content-between align-items-center">
            {row?.album || row?.image_url || row?.Thumbnail || row?.image
              ? (<img key={row?.image_url || row?.album} src={row.image_url || row.Thumbnail || row.image || row?.album}
                alt={row?.title || row?.albumname || row?.artist_name} className="profile theme-bg-color-secondary" />)
              : (<div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                {row?.title?.slice(0, 1).toUpperCase()} </div>)}
            <div className="rightVideoTitle ms-2">
              <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank" to={videoPath}><span>{`${title?.slice(0, 15)}...`}</span>
                <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: '1px', marginLeft: "6px" }} />
              </Link>
              <div className="d-flex align-items-center gap-2 ">
                <span className="dateText table-subheading theme-text-color">{row?.upload_on}</span>
                {permissionData?.userDetails?.id == row.user_id ? <span className='dateText table-subheading theme-text-color green-color-bg d-inline-block px-3 py-1 rounded-5'>{permissionData?.userDetails?.id == row.user_id ? "You" : ""}</span> : ""}
              </div>
            </div>
          </div>
        );
      },
      sort: true,
    }
    ,
    {
      dataField: "uploaded_by_role",
      text: "Upload by",
      sort: true,
      rowStyle: "px-3",
    },
    {
      dataField: "current_status",
      text: "Transcoding Status",
      width: "20%",
      formatter: (cell, row) =>
        <div className={`d-flex w-75 justify-content-center px-3 py-1 text-center`} >
          <AdminProcessButton cell={cell} row={row} />
        </div>

    },
    {
      dataField: "video_status",
      text: "Status",
      width: "10%",
      className: "px-2",
      formatter: (cell, row) => <AdminVideoStatus cell={cell} row={row} />
    },
    // {
    //   dataField: "banner",
    //   text: "Slider",
    //   formatter: (cell, row) =>
    //     <AdminSwitch name="banner" checked={cell == 1} onChange={() => handleToggle(row)} id={row?.id} />
    // },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => {
        return <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical className="theme-text-color" />
          </span>
          <div className="editdropdown-menu theme-bg-color rounded-2 overflow-hidden" >
            {draft !== 1 && (<Link to={`${"/edit-video/"}${row?.id}`} className="theme-text-color  theme-bg-color">
              <span className="theme-text-color">
                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Edit Meta" classname='ms-2 theme-text-color'></MessageBox>
              </span>
            </Link>)}
            {draft !== 1 && <Link to={`/edit-new-video/${row?.id}`} className="theme-text-color  theme-bg-color">
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text={`Edit Video`} classname='ms-2 theme-text-color'></MessageBox>
            </Link>}
            <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
              <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
            </div>
            {draft == 1 && (<div onClick={() => singlePeramanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color warningColorBg'></MessageBox>
            </div>)}
          </div>
        </div >
      }
    },
  ];
  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToDelete,
  };
  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };
  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }
  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
  }
  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };


  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const formData = {};
      const newStatus = currentItem?.banner === 1 ? 0 : 1;
      formData['video_id'] = currentItem?.id;
      formData['banner_status'] = newStatus
      const response = await axios.post(`${bannerToggle}`, formData, { headers: headers });
      const result = response.data
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };


  const handleToggle = async (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1) {
      setDeleteActionType(1)
    }
  }, [draft])


  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);

  return (
    <div className="">
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal messageClassName={deleteActionType === 1 ? "warningColor" : ""} headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"} message={deleteActionType == 2 ? "Are you sure you want to delete" : deleteActionType == 3 ? "Are you sure you want to Undo item" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to Delete"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 2 ? "Delete" : deleteActionType == 3 ? "Undo" : ""} />}
      {showModal && <AdminSliderModal modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.banner} />}

      <AdminNavbar heading={"All Videos"} totalDataLength={total?.totalItems} deleteCount={0} navigation={"/add-video"} deleteMethod={openModal} navText={"Upload Video"} />
      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
          <input type='search' id="video-search-input" placeholder='Search' name="title" className='rounded-3 col-3 theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} />
          <div className='d-flex align-items-center justify-content-end'>
            {(draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg me-2"} saveMethod={() => { setModelClose(true); setDeleteActionType(2) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Undo" className={"mx-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(3) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete Permanent" className={"me-3 warningColorBg"} saveMethod={() => { setModelClose(true); setDeleteActionType(1) }} /> : ""}
            <button id="recycleButton" className={`reloadButton custom-tool-tip-parent p-2 me-2  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin}>
              <BiRecycle style={{ width: "18px", height: "15px" }} />
              <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />
            </button>
            <button id="reloadButton" className={`bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
            </button>
            <div className="dropdown d-block ms-2" key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li id="exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                <li id="exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                <li id="exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX </li>
              </ul>
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <AdminTable data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div >
    </div>
  );
}
const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme,
  permissionData: state.userPermission.permissionData,
});

export default connect(mapStateToProps)(Allvideo)
